import React, { FC } from 'react';
import cn from 'clsx';
import { css } from 'linaria';

import AppLink from '../AppLink';
import CardImage from '../CardsGrid/CardImage';
import AutoSlat from '../AutoSlat';
import SlatButton from '../SlatButton';

import useMobile from '../../hooks/useMobile';

const maxChildNum = css`
  .part-width &:nth-child(n + 2) {
    display: none;
  }

  @screen md {
    .part-width &:nth-child(n + 2) {
      display: block;
    }
  }

  @screen lg {
    &:nth-child(n + 3) {
      display: none;
    }
  }
`;

const CategoryBlock: FC<any> = ({
  backgroundColor,
  className,
  href,
  images,
  isMobile,
  title,
  tracking,
}) => {
  const isFullBleed = images[0].shape === 'full';

  return (
    <AppLink
      className={cn('flex flex-col items-center', className)}
      href={href}
      tracking={tracking}
    >
      <div
        className={cn('flex flex-row w-full h-full justify-between items-center mb-4', {
          'px-2 py-4': isFullBleed === false,
        })}
        style={{ backgroundColor }}
      >
        {/* @ts-expect-error */}
        {images.map(({ cardClassName, className, image, mobileImage, shape }) => (
          <div className={cn('flex-1', maxChildNum)} key={isMobile ? mobileImage : image}>
            <CardImage
              alt={title}
              cardClassName={cn(cardClassName, 'shadow-lg')}
              className={className}
              shape={shape}
              src={isMobile ? mobileImage : image}
            />
          </div>
        ))}
      </div>
      <span className="tracked-medium border-b border-lapel text-lapel text-center">{title}</span>
    </AppLink>
  );
};

const CategoryBlocks: FC<any> = ({
  button,
  categories,
  className,
  mobileInline,
  tabletInline,
  title,
}) => {
  const isMobile = useMobile();

  return (
    <div className={cn('flex flex-col text-center items-center', className)}>
      {title && <AutoSlat {...title} />}
      <div
        className={cn('grid w-full justify-stretch gap-x-4', {
          'grid-cols-2': !mobileInline,
          'grid-cols-1': mobileInline,
          'md:grid-cols-3': tabletInline && categories.length === 3,
          'md:grid-cols-4': tabletInline && categories.length === 4,
          'lg:grid-cols-3': categories.length === 3,
          'lg:grid-cols-4': categories.length !== 3 && categories.length !== 5,
          'lg:grid-cols-5': categories.length === 5,
        })}
      >
        {categories.map((category: any, index: number) => (
          <CategoryBlock
            className={cn('mb-6', {
              'col-span-2 lg:col-span-1': !mobileInline && index === 0 && categories.length === 3,
              'part-width': index > 0 && categories.length === 3,
              'hidden lg:flex': categories.length > 4 && index > 3,
            })}
            key={category.title}
            {...category}
            isMobile={isMobile}
          />
        ))}
      </div>
      {button && <SlatButton {...button} />}
    </div>
  );
};

export { CategoryBlocks, CategoryBlock };

export default CategoryBlocks;
